let ApiUrls = {};
//登陆认证
ApiUrls.orgid = ''; //公司ID

ApiUrls.BASE_URL = 'http://www.lqzlsgs.com:8011/getway/' + ApiUrls.orgid; //后台服务地址

ApiUrls.queryAccount = '/mobile/queryAccount'; //查询水户账号信息

ApiUrls.checkBind = '/mobile/wx/checkBind'; //检查微信是否绑定水户信息

ApiUrls.bind = '/mobile/wx/bind'; //微信与水户绑定

ApiUrls.unBind = '/mobile/wx/unBind'; //解除绑定

ApiUrls.queryFeeList = '/mobile/fee/queryFeeList'; //查询欠费列表

ApiUrls.generateOrder = '/mobile/pay/generateOrder'; //订单生成

ApiUrls.queryWatersHisList = '/mobile/fee/queryWatersHisList'; //查询用水历史

ApiUrls.queryOrder = '/mobile/pay/queryOrder'; //查询缴费历史微信

ApiUrls.queryPayRecords = '/mobile/pay/queryPayRecords'; //查询缴费历史

ApiUrls.accessToken = '/mobile/accessToken';

ApiUrls.getWxUser = '/mobile/getWxUser';//获取头像

export default ApiUrls;


// WEBPACK FOOTER //
// ./src/common/api-urls.js